import useEnvironmentVars from './useEnvironmentVars';

/**
 *  @deprecated use useEnvironmentVars instead
 * */
const useEnviromentVars = useEnvironmentVars;

export default useEnviromentVars;
